/**
 * @generated SignedSource<<598e4b74218fb5d9ef0b38ebdd50be40>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AgreementBlock = "BAGGAGE" | "TRANSFER";
import { FragmentRefs } from "relay-runtime";
export type TermsListRow_term$data = {
  readonly agreementBlock: AgreementBlock | null;
  readonly icon: string | null;
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"EntityTableRow_entity">;
  readonly " $fragmentType": "TermsListRow_term";
};
export type TermsListRow_term$key = {
  readonly " $data"?: TermsListRow_term$data;
  readonly " $fragmentSpreads": FragmentRefs<"TermsListRow_term">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TermsListRow_term",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agreementBlock",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EntityTableRow_entity"
    }
  ],
  "type": "Term",
  "abstractKey": null
};

(node as any).hash = "cf16c83e1f32db89cf2a023b545a94e9";

export default node;
